<div class="notification-three" *ngIf="progress.isActive" [ngClass]="{'success': progress.statusClass == 'SUCCESS', 'cancel': progress.statusClass == 'FAILURE'}">
    <div class="item-icon" *ngIf="this.progress.icon">
        <i class="launch" *ngIf="this.progress.icon == 'launch'"></i>
        <i class="iconB-file-text" *ngIf="this.progress.icon == 'document'"></i>
        <i class="icon-download" *ngIf="this.progress.icon == 'download' || this.progress.icon == 'install'"></i>
        <i class="icon-upload" *ngIf="this.progress.icon == 'upload'"></i>
        <i class="iconB-test" *ngIf="this.progress.icon == 'testing'"></i>
        <i class="icon-test" *ngIf="this.progress.icon == 'training'"></i>
        <i class="iconB-version" *ngIf="this.progress.icon == 'release'"></i>
        <i class="icon-copy" *ngIf="this.progress.icon == 'copy'"></i>
        <i class="iconB-sync" *ngIf="this.progress.icon == 'sync'"></i>
    </div>
    <div class="item-content">
        <h5 [innerHTML]="progress.title"></h5>
        <h6 *ngIf="progress.startTime && progress.estimatedTime && progress.cancelFlag">{{progress.estimatedTime | trainingTime: progress.startTime}}</h6>
        <p>
            <ngb-progressbar [value]=progress.current type="info" [striped]="true" [animated]="true"></ngb-progressbar>
        </p>
        <i ngbTooltip="Minimize" placement="left" class="icon-angle-up" (click)="closeProgressBar()"></i>
        <div class="status-wrap">
            <p appDownload [innerHtml]="progress.status"></p>
        </div>
    </div>
    <div class="cancel">
        <button *ngIf="progress.cancelFlag"  (click)="cancelProgress()" class="btn animated fadeIn"><i ngbTooltip="Cancel" class="icon-cira"></i></button>
    </div>
</div>